module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent",
    staticStyle: {
      "position": "absolute"
    }
  }, [_c('mu-list', [_c('mu-sub-header', [_vm._v("今天")]), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "这个周末一起吃饭么?"
    }
  }, [_c('mu-avatar', {
    attrs: {
      "slot": "leftAvatar",
      "src": "/images/avatar1.jpg"
    },
    slot: "leftAvatar"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "describe"
    },
    slot: "describe"
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0, 0, 0, .87)"
    }
  }, [_vm._v("Myron Liu -")]), _vm._v(" 周末要来你这里出差，要不要一起吃个饭呀，实在编不下去了,哈哈哈哈哈哈\n      ")]), _vm._v(" "), _c('mu-icon-menu', {
    attrs: {
      "slot": "right",
      "icon": "more_vert",
      "tooltip": "操作"
    },
    slot: "right"
  }, [_c('mu-menu-item', {
    attrs: {
      "title": "回复"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "标记"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "删除"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "Alex Qin"
    }
  }, [_c('mu-avatar', {
    attrs: {
      "slot": "leftAvatar",
      "src": "/images/avatar2.jpg"
    },
    slot: "leftAvatar"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "describe"
    },
    slot: "describe"
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0, 0, 0, .87)"
    }
  }, [_vm._v("看电影啊")]), _vm._v(" "), _c('br'), _vm._v("\n        我们去看电影，最近有部烂片上映，又有吐槽的了\n      ")]), _vm._v(" "), _c('mu-icon-menu', {
    attrs: {
      "slot": "right",
      "icon": "more_vert",
      "tooltip": "操作"
    },
    slot: "right"
  }, [_c('mu-menu-item', {
    attrs: {
      "title": "回复"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "标记"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "删除"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "LOL"
    }
  }, [_c('mu-avatar', {
    attrs: {
      "slot": "leftAvatar",
      "src": "/images/avatar3.jpg"
    },
    slot: "leftAvatar"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "describe"
    },
    slot: "describe"
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0, 0, 0, .87)"
    }
  }, [_vm._v("去打游戏啊")]), _c('br'), _vm._v("\n        周末一起 LOL\n      ")]), _vm._v(" "), _c('mu-icon-menu', {
    attrs: {
      "slot": "right",
      "icon": "more_vert",
      "tooltip": "操作"
    },
    slot: "right"
  }, [_c('mu-menu-item', {
    attrs: {
      "title": "回复"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "标记"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "删除"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "Myron Liu"
    }
  }, [_c('mu-avatar', {
    attrs: {
      "slot": "leftAvatar",
      "src": "/images/uicon.jpg"
    },
    slot: "leftAvatar"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "describe"
    },
    slot: "describe"
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0, 0, 0, .87)"
    }
  }, [_vm._v("哇去")]), _c('br'), _vm._v(" 实在编不下去，这就是个demo\n      ")]), _vm._v(" "), _c('mu-icon-menu', {
    attrs: {
      "slot": "right",
      "icon": "more_vert",
      "tooltip": "操作"
    },
    slot: "right"
  }, [_c('mu-menu-item', {
    attrs: {
      "title": "回复"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "标记"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "删除"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f39aac9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/index.vue
// module id = 1615
// module chunks = 18